import React, { useState, useContext } from "react"

import Header from "../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import BuscarCliente from "./components/BuscarCliente"
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const AsociacionClientesProveedor = () => {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <b>Asociación de Proveedores a Cliente</b>
      <BuscarCliente></BuscarCliente>
    </ThemeProvider>
  )
}

export default AsociacionClientesProveedor
